<template>
  <div>
    <!-- App Bar with Navigation -->
    <v-app-bar v-if="isUser || isAdmin" flat>
      <template v-slot:prepend>
        <v-app-bar-nav-icon v-if="isAdmin" @click="toggleDrawer"></v-app-bar-nav-icon>
      </template>

      <v-row v-if="!isAdmin" class="d-flex align-center">
        <v-col cols="auto">
          <router-link to="/info" class="nav-item nav-link"
            ><v-img :width="300" aspect-ratio="16/9" cover :src="logo"></v-img
          ></router-link>
        </v-col>
      </v-row>

      <v-app-bar-title v-if="isAdmin && !isMobile">
        <v-row class="d-flex align-center">
          <v-col cols="auto" class="d-flex justify-start align-center">
            <router-link to="/" class="nav-item nav-link">Year {{ year.year }}</router-link>
          </v-col>
          <v-col cols="auto" style="text-align: right">
            <router-link v-if="yearId" :to="{ name: 'AdminYearEdit', params: { yearId: yearId } }">
              <v-icon icon="mdi-calendar-edit"></v-icon>
              <v-tooltip activator="parent" location="end">Edit Year</v-tooltip>
            </router-link>
          </v-col>
        </v-row>
      </v-app-bar-title>

      <v-avatar size="32">
        <v-img :src="avatar"
          ><template #sources> <source :srcset="avatar" /> </template
        ></v-img>
      </v-avatar>

      <v-list v-if="!smAndDown">
        <v-list-item
          :subtitle="!smAndDown ? email : undefined"
          :title="!smAndDown ? authStore.me?.displayName : undefined">
        </v-list-item>
      </v-list>
      <ActionButton icon="mdi-menu-down" @click="toggleProfileMenu"></ActionButton>
    </v-app-bar>

    <!-- Left Drawer: Main Navigation -->
    <v-navigation-drawer v-if="isAdmin" v-model="drawer" app temporarylocation="left">
      <v-list :lines="false" density="compact" nav>
        <!--  <NavBar v-if="isUser && !isAdmin" /> -->
        <NavBarAdmin />
      </v-list>
    </v-navigation-drawer>

    <!-- Right Drawer: Profile Options -->
    <v-navigation-drawer
      v-if="isUser || isAdmin"
      v-model="profileMenu"
      app
      temporary
      location="right">
      <v-divider></v-divider>
      <v-list density="compact" nav>
        <router-link :to="{ name: 'MyProfile' }" class="nav-item nav-link">
          <v-list-item prepend-icon="mdi-account" title="My Profile"></v-list-item>
        </router-link>
        <v-divider v-if="isUser"></v-divider>
        <router-link v-if="isUser" :to="{ name: 'OrdersListing' }" class="nav-item nav-link">
          <v-list-item prepend-icon="mdi-credit-card-outline" title="Orders"></v-list-item>
        </router-link>
        <v-divider></v-divider>
        <v-list-item prepend-icon="mdi-logout">
          <v-list-item-title @click="logout()">Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import NavBarAdmin from '@/components/ui/navigation/NavBarAdmin.vue';
import { useDisplay } from 'vuetify';
import { useAuthStore, useYearStore } from '@/stores/index';
import blankProfileUrl from '@/assets/blankProfile.webp';
import logo from '@/assets/72FilmFestFinalLogo_horz.png';
import { logout } from '@/controllers/authController';
import { YearDTO } from '@/dtos';

const authStore = useAuthStore();
const yearStore = useYearStore();
const { isAdmin, isUser } = storeToRefs(authStore);

const { smAndDown } = useDisplay();

const isMobile = computed(() => smAndDown.value);

const avatar = computed(() => authStore.avatar || blankProfileUrl);
const email = computed(() => authStore.me?.email_address);
const yearId = computed(() => yearStore.selectedYearId ?? yearStore.currentYear?.id ?? undefined);
const year = computed(() => yearStore.selectedYear.value ?? new YearDTO());

const drawer = ref(false);
const profileMenu = ref(false);

function toggleDrawer() {
  drawer.value = !drawer.value;
}

function toggleProfileMenu() {
  profileMenu.value = !profileMenu.value;
}
</script>
